import {
  EditDynamicSettings,
  SelectionT,
  useDynamicTranslation,
  useInstanceSelectionsByValueKey,
  useValueById,
  Value,
} from '@k3/core'
import { useVerandaDispatch } from '..'
import {
  removeHighlight,
  setHighlight,
} from '../store/highlights/highlightsSlice'

export const ExtraSidewallComponentInfo = ({
  selection,
}: {
  selection: SelectionT
}) => {
  const value = useValueById(selection.valueId as number)
  const childSelections = useInstanceSelectionsByValueKey(value?.key)
  const seitenwandTyp = childSelections[selection.id]?.seitenwandTyp as Value
  const dispatch = useVerandaDispatch()
  const getTranslation = useDynamicTranslation()
  return (
    <div>
      <div
        style={{
          position: 'absolute',
          top: '0',
          left: '0',
          bottom: '0',
          right: '0',
        }}
        onMouseDown={() => {
          dispatch(removeHighlight(selection.id))
        }}
        onMouseEnter={() => {
          dispatch(setHighlight({ id: selection.id }))
        }}
        onMouseLeave={() => {
          dispatch(removeHighlight(selection.id))
        }}
      />
      <>
        {getTranslation('typ')}
        <EditDynamicSettings
          keys={['typ']}
          display="dialog"
          boxProps={{ display: 'inline-flex' }}
        />
      </>
      {`: ${seitenwandTyp?.label}`}
    </div>
  )
}
